var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 531.67 587.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#1d1d1b;stroke-linecap:round;stroke-miterlimit:10;stroke-width:15px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_861",
    "data-name": "Trazado 861",
    className: "cls-1",
    d: "M292.08,446.38,547,275.21a7.09,7.09,0,0,1,8,.05L802.54,446.35a7.11,7.11,0,0,1,1.81,9.89,7.31,7.31,0,0,1-2,1.91L551.09,622a7.09,7.09,0,0,1-7.76,0L292.16,458.23a7.11,7.11,0,0,1-.08-11.85Z",
    transform: "translate(-281.43 -266.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_862",
    "data-name": "Trazado 862",
    className: "cls-1",
    d: "M682.9,760.41V536.06L549.12,446.63",
    transform: "translate(-281.43 -266.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_863",
    "data-name": "Trazado 863",
    className: "cls-1",
    d: "M682.38,760.41l-36.74,80.07a4.25,4.25,0,0,0,3.86,6h61.64a4.25,4.25,0,0,0,4.26-4.25,4.2,4.2,0,0,0-.31-1.61Z",
    transform: "translate(-281.43 -266.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_864",
    "data-name": "Trazado 864",
    className: "cls-1",
    d: "M336,486.81V616.09a12.62,12.62,0,0,0,5.38,10.33L541.84,766.81a12.6,12.6,0,0,0,14.52,0L754.27,626.44a12.63,12.63,0,0,0,5.31-10.29V486.81",
    transform: "translate(-281.43 -266.5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdu);
export default __webpack_public_path__ + "static/media/edu.7eaec8f57c8a7f949ab6e03c09af445b.svg";
export { ForwardRef as ReactComponent };